import styles from './SnowFall.module.css';
const SnowFall = () => {
  return <div className="snow" aria-hidden="true" data-sentry-component="SnowFall" data-sentry-source-file="SnowFall.tsx">
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
      <div className={styles.snowflake}>
        <div className={styles.inner}>❅</div>
      </div>
    </div>;
};
export default SnowFall;